import React, { Suspense, lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import NyafazPortalFlowLayout from "./NyafazPortalFlowLayout";
import PortalRouteFallback from "./components/PortalRouteFallback";
import Login, { RequirePortalAuth } from "./pages/Login";
import { LegacyOrgDetailRedirect, renderEnterpriseControlRoutes } from "./enterprise-control/EnterpriseControlRoutes";

const Organizations = lazy(() => import("./pages/Organizations"));
const PortalHome = lazy(() => import("./pages/PortalHome"));
const ProductRoutes = lazy(() => import("./pages/products/ProductRoutes"));
const CreateOrganization = lazy(() => import("./pages/CreateOrganization"));
const EscalatedComplaints = lazy(() => import("./pages/EscalatedComplaints"));
const Analytics = lazy(() => import("./pages/Analytics"));
const ReleaseNotes = lazy(() => import("./pages/ReleaseNotes"));

const Fallback = () => <PortalRouteFallback />;

export function renderNyafazPortalRoutes({ portalHome = false } = {}) {
  return (
    <Route element={<NyafazPortalFlowLayout />}>
      {portalHome ? <Route path="/" element={<Navigate to="/nyafaz-portal" replace />} /> : null}
      <Route path="/nyafaz-portal" element={<Login />} />
      <Route
        path="/nyafaz-portal/home"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <PortalHome />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/nyafaz-portal/organizations"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <Organizations />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/nyafaz-portal/products/:productSlug/*"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <ProductRoutes />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/nyafaz-portal/analytics/*"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <Analytics />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/nyafaz-portal/organizations/new"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <CreateOrganization />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/nyafaz-portal/organizations/:orgId"
        element={
          <RequirePortalAuth>
            <LegacyOrgDetailRedirect />
          </RequirePortalAuth>
        }
      />
      <Route
        path="/nyafaz-portal/organizations/:orgId/edit"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <CreateOrganization />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      {renderEnterpriseControlRoutes()}
      <Route
        path="/nyafaz-portal/escalated-complaints"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <EscalatedComplaints />
            </Suspense>
          </RequirePortalAuth>
        }
      />
      <Route
        path="/nyafaz-portal/release-notes"
        element={
          <RequirePortalAuth>
            <Suspense fallback={<Fallback />}>
              <ReleaseNotes />
            </Suspense>
          </RequirePortalAuth>
        }
      />
    </Route>
  );
}
